import React from 'react';
import { Section } from './ui/Section';
import { XCircle } from 'lucide-react';
export function FailedAttemptsSection() {
  const attempts = [{
    title: 'Explicar mejor',
    desc: 'Empeora, porque suena a corrección o lección.'
  }, {
    title: 'Discutir por WhatsApp',
    desc: 'Se malinterpreta todo (tono, intención, pausas).'
  }, {
    title: 'Evitar temas',
    desc: 'Baja el conflicto hoy, sube la distancia mañana.'
  }, {
    title: ', Ya, pues, así, son, ',
    desc: 'Te resigna y te deja con esa culpa de fondo.'
  }];
  return <Section background="white" data-id="element-46">
      <div className="max-w-3xl mx-auto" data-id="element-47">
        <h2 className="text-2xl md:text-3xl font-serif font-bold text-stone-900 mb-6 text-center" data-id="element-48">
          Lo que la gente intenta{' '}
          <span className="text-stone-400 font-normal" data-id="element-49">
            (y por qué no funciona)
          </span>
        </h2>

        <div className="grid gap-4" data-id="element-50">
          {attempts.map((item, idx) => <div key={idx} className="flex items-start gap-3 p-3 rounded-lg hover:bg-stone-50 transition-colors" data-id="element-51">
              <XCircle className="w-5 h-5 text-red-400 flex-shrink-0 mt-0.5" data-id="element-52" />
              <div data-id="element-53">
                <h3 className="font-bold text-stone-900 text-base" data-id="element-54">
                  {item.title}
                </h3>
                <p className="text-stone-600 text-sm" data-id="element-55">{item.desc}</p>
              </div>
            </div>)}
        </div>

        <div className="mt-8 text-center p-6 bg-stone-900 rounded-2xl text-white shadow-xl" data-id="element-56">
          <p className="text-lg md:text-xl font-serif" data-id="element-57">
            No necesitas más consejos. <br data-id="element-58" />
            Necesitas un{' '}
            <span className="text-orange-400 font-bold" data-id="element-59">método</span>.
          </p>
        </div>
      </div>
    </Section>;
}